import React, { useContext } from 'react';
import { HeaderContext } from '../../../../../../contexts/HeaderData/HeaderData';
import SearchInput from './SearchInput';

function SearchInputVM(props) {
  const { data } = useContext(HeaderContext);

  const url = data?.headerProperty?.searchPageUrl || '/exp/search';

  return <SearchInput url={url} {...props} />;
}

export default SearchInputVM;
